import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { Translate } from '@dreryk/react-common';
import { LabeledLoader, LoaderSize } from '@dreryk/react-components';

import { FormSectionHeader } from '../../common/FormSectionHeader';
import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { MedicalTreatmentConsentEnterPanel } from './MedicalTreatmentConsentEnterPanel/MedicalTreatmentConsentEnterPanel';
import { useLastMedicalTreatmentConsentQuery } from './MedicalTreatmentConsentSection.hooks';
import { MedicalTreatmentConsentWithdrawPanel } from './MedicalTreatmentConsentWithdrawPanel/MedicalTreatmentConsentWithdrawPanel';
import { loaderTransition } from './MedicialTreatmentConsentSection.transitions';

export type MedicalTreatmentConsentSectionProps = {
   readonly patientId: Patient['id'];
};

const MedicalTreatmentConsentSection = (props: MedicalTreatmentConsentSectionProps): JSX.Element => {
   const { data: medicalTreatmentConsent, loading } = useLastMedicalTreatmentConsentQuery(props.patientId);

   if (loading) {
      return (
         <LabeledLoader
            as='div'
            in={loading}
            label={patientConsentsAndAuthorizationsTranslationKeys.consent.loadingLastConsent}
            loaderSize={LoaderSize.SMALL}
            {...loaderTransition}
            testId={'loadingLastConsent'}
         />
      );
   }

   if (medicalTreatmentConsent && !medicalTreatmentConsent.withdrawalDate) {
      return (
         <div>
            <FormSectionHeader>
               <Translate>
                  {
                     patientConsentsAndAuthorizationsTranslationKeys.consent
                        .consentProvideMedicalServicesAndProcessPersonalData
                  }
               </Translate>
            </FormSectionHeader>
            <MedicalTreatmentConsentWithdrawPanel
               enterDate={medicalTreatmentConsent.enterDate}
               patientId={props.patientId}
            />
         </div>
      );
   }

   return (
      <div>
         <FormSectionHeader>
            <Translate>
               {
                  patientConsentsAndAuthorizationsTranslationKeys.consent
                     .consentProvideMedicalServicesAndProcessPersonalData
               }
            </Translate>
         </FormSectionHeader>
         <MedicalTreatmentConsentEnterPanel
            patientId={props.patientId}
            withdrawDate={medicalTreatmentConsent?.withdrawalDate}
         />
      </div>
   );
};

export { MedicalTreatmentConsentSection };
